<div class="form-container">
  <kp-eligibility-single-value
    *ngIf="isSingleValueEligibilityType"
    [eligibilityVerificationType]="eligibilityType"
    [error]="error"
    [loading]="loading"
    (errorEmitter)="error = $event"
    (loadingEmitter)="loading = $event"></kp-eligibility-single-value>
  <kp-eligibility-personal-details
    *ngIf="eligibilityType === eligibilityVerificationType.postal_dob_name"
    [error]="error"
    [loading]="loading"></kp-eligibility-personal-details>
</div>
